"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PricesSection = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _internal = require("../../hooks/internal");
var _useTranslations = require("../../hooks/useTranslations");
var _utils = require("../../utils");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const PricesSection = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    code,
    mrpStatementEnabled,
    price,
    points
  } = (0, _internal.useProduct)();
  const {
    translations
  } = (0, _useTranslations.useTranslations)();
  if (!price?.currentFormatted) {
    return null;
  }
  const {
    currentFormatted,
    old
  } = price;
  const oldPriceVisible = (0, _utils.isOldPriceVisible)({
    currentFormatted,
    old
  });
  const {
    currency: Currency,
    productPoints
  } = points ?? {};
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    "data-testid": getTestId(`${_constants.PRICES}-${code}`),
    children: [Currency != null && productPoints != null ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.GamificationPricesHolder, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.GamificationCurrentPrice, {
        "data-testid": getTestId(`${_constants.CURRENT_PRICE}-${code}`),
        fontWeight: "bold",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.CurrentPriceAndPoints, {
          children: [productPoints, /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CurrencyWrapper, {
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Currency, {
              fontSize: "inherit"
            })
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Plus, {
          children: "+"
        }), currentFormatted]
      }), oldPriceVisible ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.OldPrice, {
        "data-testid": getTestId(`${_constants.OLD_PRICE}-${code}`),
        children: [mrpStatementEnabled ? translations.mrp : translations.regularPrice, " ", old]
      }) : null]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.PricesHolder, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.CurrentPrice, {
        "data-testid": getTestId(`${_constants.CURRENT_PRICE}-${code}`),
        fontWeight: "bold",
        useOfferColor: oldPriceVisible,
        children: [!oldPriceVisible && mrpStatementEnabled ? `${translations.mrp} ` : null, currentFormatted]
      }), oldPriceVisible ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.OldPrice, {
        "data-testid": getTestId(`${_constants.OLD_PRICE}-${code}`),
        children: [mrpStatementEnabled ? `${translations.mrp} ` : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("s", {
          children: old
        })]
      }) : null]
    }), mrpStatementEnabled ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.MrpStatement, {
      variant: "caption",
      children: translations.mrpStatement
    }) : null]
  });
};
exports.PricesSection = PricesSection;
